
export default function MobileTheme1(props) {
    return(<div>Mobile Login</div>)

}